<template>
  <svg viewBox="0 0 9 16"><path fill-rule="nonzero" d="M.22.22a.75.75 0 01.976-.073L1.28.22l7 7a.75.75 0 01.073.976l-.073.084-7 7a.75.75 0 01-1.133-.976l.073-.084 6.469-6.47-6.47-6.47A.75.75 0 01.148.304L.22.22z" /></svg>
</template>

<script>
export default {
  name: 'ChevronRight'
}
</script>
